module.exports = __webpack_public_path__ + "img/xtjclfw_banner.9493f726.png";